<app-analytics-member-management [hideFilters]="hideFilters" [filters]="filters" [dashboardType]="dashboardType"></app-analytics-member-management>
